import {
  BaseCharacterState,
  CreatureAttackAnimationType,
  CreatureStateType,
  WEAPON_TYPE_TO_CLASS_MAPPING,
  WeaponClass,
} from "mmo-common";
import { PlayCharacterAnimationProps } from "../base-character/baseCharacter.gameObject";
import { getMovementAnimationSpeed } from "./movement-animation.config";

/**
 * Maps the character state to the animation to play
 */
export function mapCharacterStateToAnimation(
  state: BaseCharacterState,
  {
    showingFloatingWeapon = true,
  }: {
    showingFloatingWeapon?: boolean;
  } = {}
): PlayCharacterAnimationProps {
  const weaponType = state.character.weapon?.weaponType;
  const weaponClass = weaponType
    ? WEAPON_TYPE_TO_CLASS_MAPPING[weaponType]
    : null;
  switch (state.creature.state.type) {
    case CreatureStateType.Walk: {
      const animation =
        showingFloatingWeapon || !weaponClass
          ? "baseWalk"
          : weaponClass === WeaponClass.Sword
          ? "twoHandedWeaponRun"
          : weaponClass === WeaponClass.Dagger
          ? "ninjaRun"
          : weaponClass === WeaponClass.Staff
          ? "staffRun"
          : "baseWalk";
      return {
        name: animation,
        speed: getMovementAnimationSpeed({
          animation,
          gender: state.character.gender,
          speed: state.speed,
        }),
      } as const;
    }
    case CreatureStateType.Idle: {
      return {
        name:
          showingFloatingWeapon || !weaponClass
            ? "baseIdle"
            : weaponClass === WeaponClass.Sword
            ? "twoHandedWeaponIdle"
            : weaponClass === WeaponClass.Dagger
            ? "rogueIdle"
            : weaponClass === WeaponClass.Staff
            ? "mageIdle"
            : "baseIdle",
      } as const;
    }
    case CreatureStateType.Jump: {
      return { name: "baseJump" } as const;
    }
    case CreatureStateType.Death: {
      return { name: "baseDeath", clampWhenFinished: true } as const;
    }
    case CreatureStateType.NormalAttack: {
      switch (state.creature.state.animationType) {
        case CreatureAttackAnimationType.HorizontalSlash: {
          return {
            name: "horizontalSlash",
            duration: state.creature.state.duration,
            clampWhenFinished: true,
          } as const;
        }
        case CreatureAttackAnimationType.Attack360: {
          return {
            name: "attack360",
            duration: state.creature.state.duration,
            clampWhenFinished: true,
          } as const;
        }
        case CreatureAttackAnimationType.VerticalSlash: {
          return {
            name: "verticalSlash",
            duration: state.creature.state.duration,
            clampWhenFinished: true,
          } as const;
        }
        case CreatureAttackAnimationType.MagicAttackOneHanded: {
          return {
            name: "magicAttackOneHanded",
            duration: state.creature.state.duration,
            clampWhenFinished: true,
          } as const;
        }
      }
      return {
        name: "horizontalSlash",
        duration: state.creature.state.duration,
        clampWhenFinished: true,
      } as const;
    }
  }
}
